import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";

const selectCart = (state: RootState) => state?.cart;

export default createDraftSafeSelector(selectCart, (cart) => cart?.serverCartErrorMessage);
